import { useEffect, useRef, useMemo } from 'react'
import { useAuth } from '@/hooks/useAuth'
import useQueryGetUrgentNotification from '@/api/notification/getLiveEmergencyAlert.ts'
import useQueryGetAlertFallDetectionLive from '@/api/notification/getLiveFallDetectionAlert.ts'
import { isNotEmptyArray } from '@/util/array.ts'
import EmergencyAlertModal from '@/pages/notification/emergency/EmergencyAlertModal.tsx'
import { DISABLE_ALERTS_LIVE_FETCHING } from '@/constant/constant.ts'
import { EmergencyAlertType } from '@/api/notification/getLiveEmergencyAlert.ts'
import { useDismissedAlertStore } from '@/store/DismissedAlertStore.ts'
import { isSkVariant } from '@/util/isSkVariant.ts'

const GlobalAlertManager = () => {
    const { isLoggedIn } = useAuth()
    const skVariant = isSkVariant()
    const { data: emergencyAlerts, refetch: refetchEmergency } = useQueryGetUrgentNotification(
        isLoggedIn && !skVariant
    )
    const { data: fallAlerts, refetch: refetchFall } = useQueryGetAlertFallDetectionLive(
        isLoggedIn && !skVariant
    )
    const { dismissedAlertIds } = useDismissedAlertStore()
    const emergencyAlertDetailModalRef = useRef<any>()
    const modalShownRef = useRef(false)

    const hasEmergencyAlerts = useMemo(() => {
        const unprocessed = emergencyAlerts?.emergencies?.filter(
            (item) => item.alert.confirm === '미처리' || item.alert.confirm === undefined
        )
        const notDismissed = unprocessed?.filter((item) => !dismissedAlertIds.has(item.id))
        return isNotEmptyArray(notDismissed)
    }, [emergencyAlerts, dismissedAlertIds])

    const hasFallAlerts = useMemo(() => {
        const unprocessed = fallAlerts?.falls?.filter(
            (item) => item.alert.confirm === '미처리' || item.alert.confirm === undefined
        )
        const notDismissed = unprocessed?.filter((item) => !dismissedAlertIds.has(item.id))
        return isNotEmptyArray(notDismissed)
    }, [fallAlerts, dismissedAlertIds])

    useEffect(() => {
        if (DISABLE_ALERTS_LIVE_FETCHING || skVariant) {
            return
        }

        if ((hasEmergencyAlerts || hasFallAlerts) && !modalShownRef.current) {
            emergencyAlertDetailModalRef.current?.show()
            modalShownRef.current = true
        }
    }, [hasEmergencyAlerts, hasFallAlerts, skVariant])

    const onModalClose = () => {
        modalShownRef.current = false
        refetchEmergency()
        refetchFall()
    }

    if (skVariant) {
        return null
    }

    return (
        <>
            <EmergencyAlertModal
                ref={emergencyAlertDetailModalRef}
                refetchAlerts={onModalClose}
                defaultTab={
                    hasFallAlerts && !hasEmergencyAlerts
                        ? EmergencyAlertType.FALL
                        : EmergencyAlertType.SOS
                }
                sosAlerts={emergencyAlerts}
                fallAlerts={fallAlerts}
            />
        </>
    )
}

export default GlobalAlertManager
